// Used as vuex store module path
const MODULE_ID = 'wagenbuch';
export default MODULE_ID;
